import React from 'react';
import style from './IconBadge.css'

export default function IconBadge({icon, text}){
  return <span className={style.badge}>
    {icon}
    &nbsp;
    {text}
  </span>
}